import React from 'react';
import "../Reviews/Reviews.css";
import Slider from 'react-slick';
import starFilled from '../../images/yellow-star.svg';
import starEmpty from '../../images/grey-star.svg';
import leftArrow from '../../images/left-arrow.svg';
import rightArrow from '../../images/right-arrow.svg';


export const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
            <img src={leftArrow} alt="Prev" className='img-fluid'/>
        </div>
    );
};

export const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
        <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
            <img src={rightArrow} alt="Next" className='img-fluid'/>
        </div>
    );
};

const Reviews = ({ reviews }) => {
    const Settings = {
        // arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "305px",
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    centerPadding: "200px",
                }
            },
            {
                breakpoint: 991,
                settings: {
                    centerPadding: "120px",
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerPadding: "40px",
                }
            },
            {
                breakpoint: 575,
                settings: {
                    centerPadding: "0",
                }
            },
        ]
    };

    const renderStars = (rating) => {
        const totalStars = 5;
        return (
            <div className="star-rating">
                {Array.from({ length: totalStars }, (_, index) => (
                    <img 
                        key={index} 
                        src={index < rating ? starFilled : starEmpty} 
                        alt={index < rating ? "Filled star" : "Empty star"} 
                        className="star-img"
                    />
                ))}
            </div>
        );
    };


    return (
        <>
            <section className='reviews-wrp' id='reviews'>
                <div className='features-title'>  
                    <div className='sub-title'>  
                        <span>{reviews.subtitle}</span>
                    </div>
                    <div className='section-title'>
                        <h2>{reviews.sectiontitle}</h2>
                    </div>
                </div>
                <div className='reviews-slider'>
                    <Slider {...Settings}>
                        {reviews.items && reviews.items.map((reviews, index) => (
                            <div className='reviews-item' key={index}>
                                <div className='detail'>
                                    <p>{reviews.detail}</p>
                                </div>
                                <div className='reviews-bottom'>
                                    <div className='reviews-left'>
                                        <div className='reviews-img'>
                                            <img src={reviews.img} alt={reviews.alt} className='img-fluid' />
                                        </div>
                                        <div className='reviews-content'>
                                            <div className='block-title'>
                                                <h3>{reviews.name}</h3>
                                            </div>
                                            <p> <span>{reviews.text}</span> <img src={reviews.logo} alt={reviews.alt} className='img-fluid' /></p>
                                        </div>
                                    </div>
                                    <div className='reviews-right'>
                                        {renderStars(reviews.rating)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>
        </>
    )
}

export default Reviews;